import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { FC } from "react";
import {
    createBrowserRouter,
    Outlet,
    RouterProvider,
    ScrollRestoration,
} from "react-router";
import { BugsnagErrorBoundaryWrapper } from "./components/bugsnag-error-boundary-wrapper";
import { SharedApplicantPage } from "./pages";
import { ApiServiceProvider } from "@/contexts";
import { useApiService } from "./hooks/use-api-service";
import { apiRoutes } from "@sr-partner-portal/common";
import { config } from "./config";

const queryClient = new QueryClient({
    defaultOptions: {
        mutations: { retry: false },
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

const Root: FC = () => {
    return (
        <>
            <ScrollRestoration />
            <Outlet />
        </>
    );
};

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                path: ":token",
                element: <SharedApplicantPage />,
            },
            {
                index: true,
                loader: () => {
                    window.location.href = config.defaultRedirect;
                    return null;
                },
                element: null,
            },
            {
                path: "*",
                loader: () => {
                    window.location.href = config.defaultRedirect;
                    return null;
                },
                element: null,
            },
        ],
    },
]);


function App() {
    const apiService = useApiService(apiRoutes);

    return (
        <BugsnagErrorBoundaryWrapper>
            <QueryClientProvider client={queryClient}>
                {/** biome-ignore lint/suspicious/noExplicitAny: we only pass a partial API service here */}
                <ApiServiceProvider value={apiService as any}>
                    <RouterProvider router={router} />
                </ApiServiceProvider>
            </QueryClientProvider>
        </BugsnagErrorBoundaryWrapper>
    );
}

export default App;
